export const AUDIT_TABS = {
    CHANGES: 'CHANGES',
    STATUS: 'STATUS',
    LOGIN_LOGOUT: 'LOGIN_LOGOUT',
};